import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useCampaignActivityMutations } from "hooks/useCampaignActivityTable";

const DeleteCampaignActivityModal = ({ activity, open, onOpenChange }) => {
  const { remove } = useCampaignActivityMutations({
    onDeleted: () => onOpenChange(false),
  });

  const handleConfirm = () => remove.mutate(activity.id);

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete campaign activity?"
      description="Are you sure you want to delete this campaign activity?"
      onConfirm={handleConfirm}
    />
  );
};

export default DeleteCampaignActivityModal;
